/**
 * 장비불러 공지 상세 BottomSheet.
 *   목록(DataTable)에서 행을 누르면 열린다: $j.Ui.BS.open({ target:'$j.F.Mobile.NoticeBS', data:{ num } })
 *   본문은 /m/ajax/notice/{id} 로 받아 그대로 렌더. 약관개정 공지는 terms-notice 마크업이라
 *   앱 CSS(.terms-notice__*)로 자동 스타일된다.
 */
export default class NoticeBS {
    init() {
        const $c = $('#' + this.id);
        const num = this.data && this.data.num;
        // 헤더 = 「공지사항」 + 부제(분류 · 날짜). 공지 제목은 본문 큰 제목(notice-bs__title)에 두고,
        // 그 제목이 스크롤로 가려지면 헤더 제목이 공지 제목으로 바뀐다(collapseTitle).
        this.parent.setHeader({ loading: true });
        $c.html('<div class="notice-bs__loading">불러오는 중…</div>');

        $.ajax({ url: '/m/ajax/notice/' + num, method: 'GET', dataType: 'json' })
            .done((res) => {
                if (!res || !res.result) {
                    this.parent.setHeader({ title: '공지사항' });
                    $c.html('<div class="notice-bs__loading">' + ((res && res.message) || '불러오지 못했습니다.') + '</div>');
                    return;
                }
                const row = res.row || {};
                const sub = [row.category, (row.datetime || '').slice(0, 10)].filter(Boolean).join(' · ');
                this.parent.setHeader({ title: '공지사항', subtitle: this._esc(sub) });
                $c.html(this._render(row));
                this.parent.collapseTitle($c.find('.notice-bs__title'));
            })
            .fail(() => {
                this.parent.setHeader({ title: '공지사항' });
                $c.html('<div class="notice-bs__loading">네트워크 오류</div>');
            });
    }

    destroy() {}

    _esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"]/g, (c) =>
            ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    }

    _render(row) {
        const esc = (s) => this._esc(s);

        const date = (row.datetime || '').slice(0, 16);
        const img = row.image_url
            ? `<img class="notice-bs__cover" src="${row.image_url}" onclick="$j.Ui.ZoomPhoto.open('${row.image_url}')">`
            : '';

        return `
<div class="notice-bs">
    <div class="notice-bs__head">
        <h3 class="notice-bs__title">${esc(row.title)}</h3>
        <span class="notice-bs__date">${esc(date)}</span>
    </div>
    ${img}
    <div class="notice-bs__body">${row.body || ''}</div>
</div>`;
    }
}
